export default {
  GET_ALL: `#graphql
  query getDesigns($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getDesigns(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        design
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  GET_HISTORY: `#graphql
  query getDesignsHistory($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getDesignsHistory(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        _id,
        version,
        design,
        transaction,
        createdAt,
        createdBy,
        updatedBy
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  NEW: `#graphql
  mutation NewDesign($design: DesignInput!) {
    newDesign(input: $design)
    {
      design
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdateDesign($design: String!, $designUpdate: DesignUpdateInput!) {
    updateDesign(design:$design, designUpdate: $designUpdate)
    {
      design
    }            
  }`,

  DELETE: `#graphql
  mutation DeleteDesign($design: String!) {
    deleteDesign(design:$design)
    {
      design
    }            
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/design.js